import { useTranslation } from 'react-i18next';
import { useEffect, useState, useContext } from 'react';
import { useGet } from '@/query/fetchHooks';
import { Button } from '@teo/components';
import { ReactSVG } from 'react-svg';
import { Lerningpathorganisationdetails } from '@/models';
import { AuthContext } from '@/components/Contexts/AuthContext';

const CertificatesLP = ({
  setIsOpenEditModal,
  titleCertificate,
  modulesCertificate,
}: any) => {
  const { t } = useTranslation();
  const { auth } = useContext(AuthContext);
  const defaultColor = '#FDCA33';
  const defaultColor2 = '#FFF9E9';
  const defaultColor3 = '#FEEDBB';

  const initialOrg: Lerningpathorganisationdetails = {
    organisationName: 'TEO-Training BV',
    entityNumber: '0697.679.725',
    picture: '/images/TEO_logo.svg',
    useCertificates: true,
    contact: {
      name: 'Sabien Vanderstappen',
      function: 'Bestuurder',
    },
  };

  const [uploadLogo, setUploadLogo] = useState(initialOrg.picture);
  const [colorPicker, setColorPicker] = useState(defaultColor);
  const [fill, setFill] = useState(defaultColor2);
  const [fill2, setFill2] = useState(defaultColor3);
  const [isTeo, setIsTeo] = useState<boolean>();
  const [organisation, setOrganisation] = useState(initialOrg);
  const [loaded, setLoaded] = useState(false);

  const { data, status } = useGet<Lerningpathorganisationdetails>(
    `/organisation/${auth?.user?.activeOrganisationId}`,
    {
      onSuccess: (result: any) => {
        if (result.data?.issueCertificates) {
          setOrganisation({
            organisationName: result.data?.organisationName,
            entityNumber: result.data?.entityNumber,
            picture: result.data?.picture,
            contact: {
              name: result.data?.contact.name,
              function: result.data?.contact.function,
            },
            useCertificates: result.data?.useCertificates,
            issueCertificates: result.data?.issueCertificates,
            certificateColor: result.data?.certificateColor,
          });
          setUploadLogo(result.data?.picture);
        } else {
          setOrganisation({
            ...initialOrg,
            useCertificates: result.data?.useCertificates,
            issueCertificates: result.data?.issueCertificates,
            certificateColor: result.data?.certificateColor,
          });
        }
        setIsTeo(!result.data?.issueCertificates);
        setColorPicker(result.data?.certificateColor);
      },
    }
  );

  useEffect(() => {
    if (colorPicker) {
      setFill(lightenHexColor(colorPicker, 0.9));
      setFill2(lightenHexColor(colorPicker, 0.7));
    }
  }, [colorPicker]);

  useEffect(() => {
    if (data?.data && !isTeo) {
      setOrganisation((prev: any) => ({
        ...prev,
        organisationName: data?.data?.organisationName,
        entityNumber: data?.data?.entityNumber,
        picture: data?.data?.picture,
        contact: {
          name: data?.data?.contact.name,
          function: data?.data?.contact.function,
        },
      }));
      setUploadLogo(data?.data?.picture);
    }
    if (data?.data && isTeo) {
      setOrganisation({
        ...initialOrg,
        useCertificates: organisation.useCertificates,
        certificateColor: data?.data?.certificateColor,
      });
      setUploadLogo(initialOrg.picture);
    }
    setLoaded(true);
  }, [isTeo]);

  const lightenHexColor = (hex: string, percent: number): string => {
    hex = hex.replace('#', '');

    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    r = Math.min(255, Math.floor(r + (255 - r) * percent));
    g = Math.min(255, Math.floor(g + (255 - g) * percent));
    b = Math.min(255, Math.floor(b + (255 - b) * percent));

    const toHex = (n: number) => n.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };

  if (!loaded) return null;

  return (
    <div className="w-full">
      <div className="relative mt-5 min-h-[225px] max-w-[321px]">
        <ReactSVG
          className="absolute inset-0 z-0"
          src={'/images/components/organisation/teo_cert.svg'}
          renumerateIRIElements={false}
          beforeInjection={(svg) => {
            svg.setAttribute('style', 'width: 100%; height: 100%; ');
            // const rect = svg.querySelector('rect') as SVGRectElement;

            const rect = svg.querySelector('#Frame_2') as SVGRectElement;
            rect.setAttribute('fill', fill);
            rect.setAttribute('stroke', fill2);

            const rect2 = svg.querySelector('#Frame_3') as SVGRectElement;
            rect2.setAttribute('stroke', fill2);

            const rects = svg.querySelectorAll('[name="cover"]');
            rects.forEach((rect) => {
              rect.setAttribute('fill', fill2);
            });

            const elements = svg.querySelectorAll('[name="letter"]');
            elements.forEach((el) => {
              el.setAttribute('fill', colorPicker);
            });
          }}
          onError={(error) => {
            console.error(error);
          }}
          // todo: more efficient way after injection and useState?
          // afterInjection={(svg) => {
          // if (svgLoaded) return;
          // setSvg(svg);
          // }} px-14
        />
        <div className="z-1 relative flex min-h-[225px] flex-col py-5 px-5">
          <div className="grid grid-cols-5 gap-1">
            <div className="col-span-3 p-2">
              <p className="text-[8px] font-medium text-grey-08">
                {t('pages.manage_certificates.example.certificate')}
              </p>
              <h2 className=" text-[10px] leading-[1.6]">
                {titleCertificate
                  ? titleCertificate
                  : t('pages.manage_certificates.example.course')}
              </h2>
              <p className="hidden text-[8px] font-normal text-grey-08 lg:block">
                {organisation.organisationName +
                  ' ' +
                  t('pages.manage_certificates.example.confirm')}
              </p>
              <h3 className=" text-[10px] leading-[1.8]">Georg Ohm</h3>
              <p className="hidden text-[6px] text-grey-08 lg:block">
                {t('pages.manage_certificates.example.success')} <br />
                {`"${
                  titleCertificate
                    ? titleCertificate
                    : t('pages.manage_certificates.example.course')
                }"`}
                <br />
                {t('pages.manage_certificates.example.modules_info')}
              </p>
              {modulesCertificate?.length > 0 ? (
                <div className="mt-1">
                  {modulesCertificate?.map((mdl: any, i: any) => {
                    return (
                      <p
                        className=" hidden text-[8px] font-semibold text-grey-08 lg:block"
                        key={i}
                      >
                        {mdl}
                      </p>
                    );
                  })}
                </div>
              ) : (
                <p className=" hidden py-1 text-[8px] font-semibold text-grey-08 lg:block">
                  {t('pages.manage_certificates.example.modules_1')}
                  <br />
                  {t('pages.manage_certificates.example.modules_2')}
                  <br />
                  {t('pages.manage_certificates.example.modules_3')}
                </p>
              )}
            </div>
            <div className=" col-span-2">
              <div
                className={`float-right h-3/6 w-2/4 bg-contain  bg-no-repeat px-0.5 opacity-10 grayscale`}
              >
                {uploadLogo && <img src={uploadLogo} className="w-full" />}
              </div>
              {/* <div className={`bg-[url('/images/TEO_logo.svg')] bg-no-repeat bg-contain h-3/6 w-2/4  opacity-10 grayscale float-right`}>
                  </div> */}
              {isTeo && (
                <p className="clear-right block pt-12 text-[8px] text-grey-05">
                  {t('pages.manage_certificates.example.signature')}
                </p>
              )}
            </div>
          </div>
          <p className="mt-auto block pl-2  text-[5px] font-normal text-grey-05 ">
            {t('pages.manage_certificates.example.issuance') +
              ' ' +
              organisation.contact.name +
              ' - ' +
              organisation.contact.function +
              ' ' +
              organisation.organisationName +
              ' ' +
              organisation.entityNumber}
          </p>
        </div>
      </div>

      <Button
        size="sm"
        variant="outline"
        className="mt-6"
        onClick={() => setIsOpenEditModal(true)}
      >
        {t('pages.learning_path.settings.edit_certificate')}
      </Button>
    </div>
  );
};

export default CertificatesLP;
